module.exports = __webpack_public_path__ + "assets/6838eaafa851ce0587da15f8ab1e97c8.mp3";